'use client'
import React, { useState } from 'react';
import Image from 'next/image';
import '@/app/main.css';

const faqs = [
  {
    question: "What’s the difference between WordPress and Shopify?",
    answer: "WordPress is a flexible content management system ideal for blogs, service-based websites, and custom projects. Shopify is an all-in-one eCommerce platform designed for creating and managing online stores. We help you choose the right platform based on your goals."
  },
  {
    question: "Do you offer custom design and development for both platforms?",
    answer: "Yes. Whether you need a custom theme, plugin integration, or tailored functionality, we provide end-to-end design and development services for both WordPress and Shopify — ensuring your site is unique, fast, and scalable."
  },
  {
    question: "Can you migrate my existing website to WordPress or Shopify?",
    answer: "Absolutely. We offer seamless website migration services, including content transfer, design adaptation, SEO preservation, and testing — ensuring a smooth transition with minimal downtime."
  },
  {
    question: "Will my WordPress or Shopify website be SEO-optimized and mobile-friendly?",
    answer: "Yes. All websites we build are responsive across devices and follow SEO best practices like clean code, fast load times, structured data, and optimized content — helping your site rank better in search results."
  },
  {
    question: "Do you provide training or support after the website is launched?",
    answer: "Definitely. We offer post-launch support, including training on how to manage your WordPress or Shopify site, make content updates, add products, and handle orders — so you’re fully in control."
  },
];

function FaqSection() {
  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div>
      <div className="col text-center py-5 mt-5" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
        <h3>FAQ's</h3>
      </div>

      {/* Shapes */}
      <Image src="/shape1.svg" width={202} height={202} alt="shape" className="shape1" />
      <Image src="/shape2.svg" width={22} height={22} alt="shape" className="shape2 rotateme" />

      <div className="faq-area ptb-20">
        <div className="container" data-aos="fade-up" data-aos-delay="100" data-aos-duration="500" data-aos-once="true">
          <div className="faq-accordion accordion">
            {faqs.map((item, index) => (
              <div key={index} className="accordion__item">
                <div
                  className="accordion__heading faq-heading"
                  role="heading"
                  aria-level={3}
                  data-aos="fade-up"
                  data-aos-delay="100"
                  data-aos-duration="500"
                  data-aos-once="true"
                >
                  <div
                    className="accordion__button"
                    role="button"
                    tabIndex={0}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                    data-aos="fade-up"
                    data-aos-delay="100"
                    data-aos-duration="500"
                    data-aos-once="true"
                  >
                   <span
  className={`transition-colors duration-200 cursor-pointer 
    hover:text-purple-600 
    ${openIndex === index ? "text-purple-600 font-semibold" : ""}`}
>{item.question}</span>
                  </div>
                </div>
                {openIndex === index && (
                  <div className="accordion__panel faq-ans">
                    <p>{item.answer}</p>
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default FaqSection;
